import React from 'react'

import { useSelector } from 'react-redux'

import { P } from '../../../style/Typography.style'

import useFetch from '../../../hooks/useFetch'

const ApplicantWithdrawalComment = ({ talent }) => {
  const { selectedInterview } = useSelector((state) => state.requisitions)
  const { data } = useFetch(
    `/applicant/withdrawals?applicant_id=${talent.id}&job_id=${selectedInterview.job_id}`
  )

  return (
    <>
      <P color="#DC2929" weight="500" padding="0.5rem 0 0.25rem 0">
        WITHDRAWAL COMMENTS:
      </P>
      <P
        dangerouslySetInnerHTML={{
          __html: data?.resp[0]?.reason || 'No withdrawal comments.',
        }}
        padding="0 0 0.25rem 0"
      />
    </>
  )
}

export default ApplicantWithdrawalComment
